export type SubscriptionTier = 'free' | 'plus' | 'pro';

export const TIER_LIMITS = {
    free: {
        maxSubscriptions: 10,
        analyticsHistoryDays: 30,
    },
    plus: {
        maxSubscriptions: Infinity,
        analyticsHistoryDays: 365,
    },
    pro: {
        maxSubscriptions: Infinity,
        analyticsHistoryDays: Infinity,
    },
} as const;

export const FEATURE_FLAGS = {
    csvExport: ['plus', 'pro'],
    pdfExport: ['pro'],
    gmailIntegration: ['pro'],
    customCategories: ['plus', 'pro'],
    multiCurrency: ['plus', 'pro'],
    customReminders: ['plus', 'pro'],
} as const;

export function hasFeature(tier: SubscriptionTier, feature: keyof typeof FEATURE_FLAGS): boolean {
    return FEATURE_FLAGS[feature].includes(tier);
}

export function getSubscriptionLimit(tier: SubscriptionTier): number {
    return TIER_LIMITS[tier].maxSubscriptions;
}
